import { Box, Typography, Skeleton } from '@mui/material';
import { styled } from '@mui/material/styles';

export const WheelWrapper = styled(Box)(({ theme }) => {
  return {
    display: 'flex',
    justifyContent: 'center',
    position: 'relative',
    overflow: 'hidden',
    marginLeft: 'auto',
    marginRight: 'auto',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      height: '400px',
      marginTop: '40px',
      '&>div': {
        position: 'absolute',
      },
    },
  };
});

export const WheelSkeleton = styled(Skeleton)(({ theme }) => {
  return {
    display: 'flex',
    justifyContent: 'center',
    position: 'relative',
    overflow: 'hidden',
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '100%',
    height: '698px',
    background: '#0d0d0f',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      height: '400px',
      marginTop: '40px',
      '&>div': {
        position: 'absolute',
      },
    },
  };
});
